module.exports = __webpack_public_path__ + "img/huawei-app-gallery.a374f129.svg";